import { useSelector, useDispatch } from "react-redux";
import { addCoupon, removeCoupon, initializePlan } from "@actions/tunnel-steps-actions";
import redeemTypes from "@utils/constants/redeemTypes";
import { getSubscriptionCoupon } from "@utils/call-api/coupons-call";
import { useCallback } from "react";

export function useTunnelSteps() {
  const tunnelSteps = useSelector((state) => state.tunnelSteps);
  const referralProgram = useSelector((state) => state.features?.referral_program);

  const couponToApply = () => {
    if (!tunnelSteps.coupon?.valid) return null;

    return tunnelSteps.coupon?.type === redeemTypes.referring
      ? referralProgram.referree_coupon
      : tunnelSteps.coupon;
  };

  const discountType = () => {
    if (!tunnelSteps.coupon?.valid) return null;

    return tunnelSteps.coupon.type === redeemTypes.referring ? "referring" : "coupon";
  };

  return {
    ...tunnelSteps,
    referralProgramVersion: referralProgram?.current_version,
    discountType: discountType(),
    couponToApply: couponToApply(),
  };
}

export function useAddCoupon() {
  const dispatch = useDispatch();

  return useCallback(
    (coupon) => {
      dispatch(addCoupon(coupon));
    },
    [dispatch],
  );
}

export function useInitializePlan() {
  const dispatch = useDispatch();

  return () => dispatch(initializePlan());
}

export function useRemoveCoupon() {
  const dispatch = useDispatch();

  return () => dispatch(removeCoupon());
}

export function useCheckAgainForCouponValidity() {
  const coupon = useSelector((state) => state.tunnelSteps?.coupon);
  const dispatch = useDispatch();

  return async () => {
    const code = coupon?.referringToken || coupon?.name;
    if (!code) return;

    const couponRes = await getSubscriptionCoupon(code);

    if (couponRes.error_code) dispatch(removeCoupon());
  };
}
